import { useEffect, useState } from "react";

/**
 * True once `delaySeconds` has passed for this announcement.
 * Dismissing it starts the wait again for the next one, even when the delay matches.
 */
export function useAnnouncementDelay(
  delaySeconds: number = 0,
  announcementId?: number,
) {
  const [readyForId, setReadyForId] = useState<number | undefined>(
    delaySeconds <= 0 ? announcementId : undefined,
  );

  useEffect(() => {
    if (delaySeconds <= 0) {
      setReadyForId(announcementId);
      return;
    }

    setReadyForId(undefined);
    const timer = setTimeout(
      () => setReadyForId(announcementId),
      delaySeconds * 1000,
    );

    return () => clearTimeout(timer);
  }, [announcementId, delaySeconds]);

  return delaySeconds <= 0 || readyForId === announcementId;
}
